import api from "./api";

export function registerSW() {
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.register("/sw.js").catch(() => {});
  }
}

export function updateBadge(n) {
  try {
    if ("setAppBadge" in navigator) {
      if (n > 0) navigator.setAppBadge(n); else navigator.clearAppBadge();
    }
  } catch (e) { /* non supportato */ }
}

export function pushSupported() {
  return "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;
}

export function pushEnabled() {
  return pushSupported() && Notification.permission === "granted";
}

export const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent) ||
  (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
export const isStandalone = window.matchMedia?.("(display-mode: standalone)")?.matches ||
  window.navigator.standalone === true;

function report(passo, ok, dettaglio = "") {
  api.post("/push/diag", {
    passo, ok, dettaglio: String(dettaglio).slice(0, 300),
    dispositivo: navigator.userAgent.slice(0, 200),
    standalone: !!isStandalone,
    permesso: "Notification" in window ? Notification.permission : "assente",
  }).catch(() => {});
}

function urlB64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = window.atob(base64);
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
}

/** Controlli passo per passo, da mostrare all'utente e registrare nel CRM. */
export async function diagnose() {
  const checks = [];
  const add = (nome, ok, nota = "") => checks.push({ nome, ok, nota });
  add("App aperta dalla schermata Home", !isIOS || isStandalone,
    isIOS && !isStandalone ? "Su iPhone le notifiche funzionano solo dall'icona sulla Home, non da Safari" : "");
  add("Service worker disponibile", "serviceWorker" in navigator);
  add("Notifiche supportate dal browser", pushSupported());
  add("Permesso notifiche", "Notification" in window && Notification.permission === "granted",
    "Notification" in window ? `stato: ${Notification.permission}` : "API assente");
  let subscribed = false;
  try {
    if ("serviceWorker" in navigator) {
      const reg = await navigator.serviceWorker.getRegistration();
      add("Service worker registrato", !!reg, reg ? "" : "ricarica l'app per registrarlo");
      const sub = reg && reg.pushManager ? await reg.pushManager.getSubscription() : null;
      subscribed = !!sub;
    }
  } catch (e) { /* ignora */ }
  add("Dispositivo iscritto alle notifiche", subscribed);
  report("autodiagnosi", checks.every((c) => c.ok), checks.filter((c) => !c.ok).map((c) => c.nome).join("; "));
  return checks;
}

export async function enablePush() {
  if (isIOS && !isStandalone) {
    report("attivazione", false, "aperta da Safari, non dalla Home");
    throw new Error("Su iPhone apri prima il CRM dall'icona sulla schermata Home (Condividi → Aggiungi alla schermata Home), poi riprova da qui.");
  }
  if (!pushSupported()) {
    report("attivazione", false, "pushSupported=false");
    throw new Error("Notifiche non supportate su questo dispositivo/browser. Su iPhone serve iOS 16.4 o successivo.");
  }
  let perm;
  try {
    perm = await Notification.requestPermission();
  } catch (e) {
    report("permesso", false, e.message);
    throw new Error(`Richiesta permesso non riuscita: ${e.message}`);
  }
  if (perm !== "granted") {
    report("permesso", false, perm);
    throw new Error(`Permesso notifiche non concesso (${perm}). Su iPhone: Impostazioni → Notifiche → CRM Studio.`);
  }
  let reg;
  try {
    reg = await navigator.serviceWorker.ready;
  } catch (e) {
    report("service-worker", false, e.message);
    throw new Error(`Service worker non pronto: ${e.message}. Chiudi e riapri l'app, poi riprova.`);
  }
  let key;
  try {
    const { data } = await api.get("/push/vapid-key");
    key = data.key;
  } catch (e) {
    report("vapid", false, e.message);
    throw new Error(`Chiave notifiche non recuperata: ${e.message}`);
  }
  let sub;
  try {
    sub = await reg.pushManager.getSubscription();
    if (sub) await sub.unsubscribe().catch(() => {});
    sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlB64ToUint8Array(key),
    });
  } catch (e) {
    report("iscrizione", false, `${e.name}: ${e.message}`);
    throw new Error(`Iscrizione alle notifiche rifiutata dal telefono: ${e.message}`);
  }
  await api.post("/push/subscribe", { subscription: sub.toJSON(), dispositivo: navigator.userAgent.slice(0, 200) });
  report("attivazione", true, sub.endpoint.slice(0, 60));
  return true;
}
